import { render, staticRenderFns } from "./MainCard.vue?vue&type=template&id=5f6022ee&scoped=true&"
import script from "./MainCard.vue?vue&type=script&lang=js&"
export * from "./MainCard.vue?vue&type=script&lang=js&"
import style0 from "./MainCard.vue?vue&type=style&index=0&id=5f6022ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6022ee",
  null
  
)

export default component.exports